{
  "pageTitle": "Rules and policies",
  "pageIntro": "The documents below are drafts for the VBB PLAY platform. They are not ready for production publishing until company name, licence details and governing law are confirmed by the owner.",
  "draftBadge": "DRAFT — pending approval",
  "backToList": "Back to all rules",
  "updatedLabel": "Version",
  "version": "0.2-draft",
  "footerNote": "These texts are not an approved legal version. They will go live only after separate permission.",
  "navTitle": "Rules",
  "categories": {
    "terms": {
      "title": "Terms of use",
      "summary": "Account creation, platform use and core obligations.",
      "sections": [
        {
          "heading": "1. General",
          "body": "VBB PLAY is a platform offering online games and related services. By registering or using the service you accept these terms. Official company name, registration country and licence details will be added after owner confirmation."
        },
        {
          "heading": "2. Account",
          "body": "Each user may hold only one personal account. You are responsible for keeping credentials confidential. Suspicious or shared accounts may be restricted."
        },
        {
          "heading": "3. Age and eligibility",
          "body": "The service is for persons of legal age only. Eligibility checks may be required. Accounts may be closed if age or jurisdiction rules are not met."
        },
        {
          "heading": "4. Prohibited conduct",
          "body": "Fraud, abuse via automation, interfering with another person’s account and unlawful activity are forbidden."
        },
        {
          "heading": "5. Service changes",
          "body": "Features, game catalogue and interface may change or be temporarily suspended with notice where practical."
        },
        {
          "heading": "6. Contact",
          "body": "Use Live Support for disputes and questions. An official legal address will be published after confirmation."
        }
      ]
    },
    "privacy": {
      "title": "Privacy policy",
      "summary": "Collection, storage and use of personal data.",
      "sections": [
        {
          "heading": "1. Data we process",
          "body": "Account and contact details, payment metadata, device/technical logs and support messages may be processed."
        },
        {
          "heading": "2. Purpose",
          "body": "Data is used for account management, security, payment processing, support and legal obligations."
        },
        {
          "heading": "3. Sharing",
          "body": "Data is not sold. It may be shared with payment providers, game aggregators and authorities when legally required."
        },
        {
          "heading": "4. Retention",
          "body": "Data is kept only as long as needed for service and legal requirements, then deleted or anonymised."
        },
        {
          "heading": "5. Your rights",
          "body": "You may request access, correction or deletion via support, subject to lawful retention exceptions."
        },
        {
          "heading": "6. Security",
          "body": "Technical and organisational measures are applied; no system is risk-free."
        }
      ]
    },
    "bonuses": {
      "title": "Bonus terms",
      "summary": "Bonuses, promo codes and lucky wheel conditions.",
      "sections": [
        {
          "heading": "1. General",
          "body": "Bonuses, promo codes and wheel rewards depend on campaign terms and account status. Each campaign may have its own limits."
        },
        {
          "heading": "2. Real and bonus balances",
          "body": "Real and bonus funds are tracked separately. Bonus play is allowed only in eligible games."
        },
        {
          "heading": "3. Wagering",
          "body": "Wagering or conversion requirements are stated in the campaign. Unmet conditions may lead to bonus cancellation."
        },
        {
          "heading": "4. Abuse",
          "body": "Multiple accounts, bonus abuse or circumvention may result in cancelled bonuses and account limits."
        },
        {
          "heading": "5. Changes",
          "body": "Campaigns may be paused or changed. Transition rules for active bonuses are shown in the campaign text or via support."
        }
      ]
    },
    "payments": {
      "title": "Deposits and withdrawals",
      "summary": "Payment methods, limits and review process.",
      "sections": [
        {
          "heading": "1. Deposits",
          "body": "Deposits are accepted only via active methods. Wrong network, wrong details or wrong amount may delay or lose funds."
        },
        {
          "heading": "2. Withdrawals",
          "body": "Withdrawal requests may be reviewed. The same method and/or KYC may be required. Limits depend on method and account status."
        },
        {
          "heading": "3. Currency",
          "body": "The main account currency is the one shown on the platform. Conversion and fees depend on the method."
        },
        {
          "heading": "4. Receipts and checks",
          "body": "Some methods require a receipt or extra confirmation. Submitting forged documents is forbidden."
        },
        {
          "heading": "5. Refunds",
          "body": "Erroneous or duplicate transactions are investigated with support and payment partners based on facts."
        }
      ]
    },
    "responsible": {
      "title": "Responsible gaming",
      "summary": "Self-limits and prevention of harmful play.",
      "sections": [
        {
          "heading": "1. Principle",
          "body": "Gaming is for entertainment. Wins are not guaranteed. Do not play with money you cannot afford to lose."
        },
        {
          "heading": "2. Tools",
          "body": "Cooling-off, self-exclusion and account closure requests may be available in security/profile or via support."
        },
        {
          "heading": "3. Help",
          "body": "If you feel at risk of gambling harm, seek professional help and restrict your account."
        },
        {
          "heading": "4. Minors",
          "body": "Underage participation is forbidden. Such accounts are closed."
        }
      ]
    },
    "kyc": {
      "title": "Account verification (KYC)",
      "summary": "Identity and contact verification.",
      "sections": [
        {
          "heading": "1. When",
          "body": "KYC may be requested for withdrawals, high amounts, risk signals or legal requirements."
        },
        {
          "heading": "2. Documents",
          "body": "ID/passport, address proof and payment-method proof may be required. Support will clarify the list."
        },
        {
          "heading": "3. Processing",
          "body": "Data is processed only for verification and stored under the privacy policy."
        },
        {
          "heading": "4. Outcome",
          "body": "Some operations may stay limited until verification completes. Mismatch may lead to account closure."
        }
      ]
    },
    "aml": {
      "title": "AML and anti-fraud",
      "summary": "Preventing suspicious transactions.",
      "sections": [
        {
          "heading": "1. Purpose",
          "body": "The platform aims to prevent money laundering, fraud and sanctions breaches."
        },
        {
          "heading": "2. Monitoring",
          "body": "Transactions, login patterns and account behaviour may be reviewed automatically and/or manually."
        },
        {
          "heading": "3. Measures",
          "body": "Suspicious activity may pause deposits/withdrawals, freeze an account and, where required by law, be reported to authorities."
        },
        {
          "heading": "4. Cooperation",
          "body": "Users must respond promptly to support requests for extra information."
        }
      ]
    },
    "fairplay": {
      "title": "Fair play and age",
      "summary": "Game fairness, provider rules and age limits.",
      "sections": [
        {
          "heading": "1. Providers",
          "body": "Games may be supplied by third-party providers. Their rules and RNG/fairness mechanisms apply."
        },
        {
          "heading": "2. Outcomes",
          "body": "Results are determined by the provider system. Technical incidents may lead to session review."
        },
        {
          "heading": "3. Age",
          "body": "Real-money play is only for users of legal age. Age confirmation may be required."
        },
        {
          "heading": "4. Language",
          "body": "Provider UIs appear only in languages they support. If your selected language is unsupported, the provider fallback language may be used."
        }
      ]
    },
    "self_exclusion": {
      "title": "Self-Restriction Policy",
      "summary": "Cooling-off, self-exclusion and temporary or permanent account restriction.",
      "sections": [
        {
          "heading": "1. Purpose",
          "body": "This policy offers tools to pause or limit gaming activity to support responsible use."
        },
        {
          "heading": "2. Tools",
          "body": "Cooling-off, self-exclusion and account-closure requests may be available in security/profile or via Live Support, depending on active platform configuration."
        },
        {
          "heading": "3. Effect",
          "body": "When self-restriction is active, deposits, play or other selected actions may be limited. Early removal before the period ends is usually not available."
        },
        {
          "heading": "4. Request process",
          "body": "Support requests are reviewed. Identity confirmation may be required. Processing time depends on the request type."
        },
        {
          "heading": "5. Responsibility",
          "body": "These tools help reduce risk but do not replace professional help. Seek professional support if needed."
        },
        {
          "heading": "6. Legal note",
          "body": "Company details and governing law will be added after owner confirmation. This text is a draft."
        }
      ]
    },
    "disputes": {
      "title": "Dispute Resolution Policy",
      "summary": "How payment, bonus, game-result and account disputes are reviewed.",
      "sections": [
        {
          "heading": "1. Scope",
          "body": "This policy covers disputes about deposits/withdrawals, bonuses, account status and game sessions."
        },
        {
          "heading": "2. First contact",
          "body": "Report the issue first via Live Support. Include order/request ID, date, amount and evidence where possible (receipt, screenshot)."
        },
        {
          "heading": "3. Investigation",
          "body": "Support may review logs, payment metadata and provider data. Game outcomes may rely on third-party provider systems."
        },
        {
          "heading": "4. Timing",
          "body": "Simple cases are usually reviewed faster; complex or third-party checks may take longer. Exact SLA will be published after owner confirmation."
        },
        {
          "heading": "5. Outcome",
          "body": "Decisions are based on facts. Corrections, refunds or explanations may be provided where appropriate. Forged documents or abuse may lead to account limits."
        },
        {
          "heading": "6. Escalation",
          "body": "Further escalation routes and an official legal address will be added after confirmation. This text is a draft."
        }
      ]
    }
  }
}
